<div [formGroup]="group" class="carrier-ctn cf">
    <div class="col-to-row-s-tb"><div class="col-xs-12">
        <h2 *ngIf="config.title">{{ config.title }}</h2>
    </div></div>
    <div class="col-to-row-s-tb ctn-top">
        <div class="field-sep flex-1">
            <chips-field
                [setMaj]="true"
                [label]="Yii.t('wui-shared-js', 'Compagnies Préférées')"
                [group]="group"
                controlName="preferred"
                [excludeValue]="getValue(['include', 'exclude'])"></chips-field>
        </div>
        <div class="field-sep flex-1">
            <chips-field
                [setMaj]="true"
                [label]="Yii.t('wui-shared-js', 'Compagnies Incluses')"
                [group]="group"
                controlName="include"
                [excludeValue]="getValue(['preferred', 'exclude'])"></chips-field>
        </div>
        <div class="flex-1">
            <chips-field
                [setMaj]="true"
                [label]="Yii.t('wui-shared-js', 'Compagnies Exclues')"
                [group]="group"
                controlName="exclude"
                [excludeValue]="getValue(['include', 'preferred'])"></chips-field>
        </div>
    </div>
</div>
